import React from 'react';
import { Grid, Typography, Avatar, Box } from '@mui/material';
import defaultShopLogo  from '../../assets/images/default_shop_logo.png'
import { styled } from '@mui/system';

const GradientGrid = styled(Grid)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
     background: `linear-gradient(36deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 54%, ${theme.palette.primary.light} 100%)`,
    //background: `linear-gradient(36deg, rgb(211, 211, 21) 0%, #F0EAD6 54%, rgb(211, 211, 211) 100%)`,
    padding: '25px',
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
    fontSize: '1.15rem',
  }));

export default function Header({formDetails}) {
  return (
    <GradientGrid container spacing={0} alignItems="center" sx={{bgcolor: 'blue',// Responsive styles
      '@media (max-width:600px)': {paddingLeft:"0px" , paddingRight:"0px"}}}>
      <Box md={2} xs={3} justifyContent="center" sx={{marginLeft:'2%'}}>
        <Avatar
          alt="Profile Image"
          src={defaultShopLogo}
          sx={{ width: 80, height: 80, backgroundColor:'transparent', borderRadius: 0, }}
        />
      </Box>
      <Box md={10} xs={9} sx={{maxWidth:"75%"}}>
        <Typography variant="h5" sx={{margin:'0px'}} pl={"5%"}>  { formDetails.displayName || "Lyra Network PVT LTD"}</Typography>
        {/* <Typography variant="h5" sx={{margin:'0px'}} pl={"5%"}> Lyra Network PVT LTD Lyra Network PVT LTD</Typography> */}
        <Typography variant="body2" pl={"5%"}>
        { formDetails.address || " "}
        </Typography>
      </Box>
    </GradientGrid>
  );
}
